import React, { Component } from 'react';
import XLogo from '../assets/img/x-black.png';
import UserLogo from '../assets/img/user.png';
import DateSelect from '../components/DateSelect';
import { AuthContext } from '../context/AuthContext';
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { dhakaArea, savarArea, ctgArea } from '../helpers/Areas';
import LoadingBtn from '../components/LoadingBtn';
import { Helmet } from 'react-helmet';
import { Spinner } from 'react-bootstrap';

import MomentUtils from '@date-io/moment';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  DatePicker,
} from '@material-ui/pickers';

class CheckoutMbl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectLoopItem: dhakaArea,
      dhakaAreaName: dhakaArea,
      savarAreaName: savarArea,
      ctgAreaName: ctgArea,
      carts: [],
      subTotal: null,
      user: null,

      userAddresses: [],
      district: '',
      thana: '',
      address: `Flat no/Level: \nHouse: \nRoad: \nBlock: \nDetails: `,
      mobile: '',
      email: '',
      addressId: null,

      date: null,
      reference: '',
      deliveryCopy: 'both',
      all_total_price: 0,
      fees: { meterial_fee: 0, collection_fee: 0, delivery_fee: 0 },
      feesApi: {
        meterial_fee: 0,
        collection_fee: 0,
        collection_fee_extend: 0,
        delivery_fee: 0,
        inactive_test: false,
        test: null,
      },
      // Raw fee rules from the API, kept so material fee can be evaluated per
      // patient (each patient's own tests may match a different rule) instead
      // of using a single rule for the whole order.
      feeRules: [],

      coupon: '',

      toady: moment().format('YYYY-MM-DD'),
      showDiscount: false,
      discountAmount: null,
      cuponId: null,
      materialPerson: null,
      ifUserOrder: null,
      labDiscount: null,
      placeOrderLoading: false,
      labDisLoading: false,
      brandDiscount: null,
      selectTerms: false,
    };
  }

  evaluateBrandDiscount = (activeCarts) => {
    const carts = activeCarts || this.state.carts || [];
    if (!carts || carts.length === 0) {
      this.setState({ brandDiscount: null });
      return;
    }
    const patientOrders = this.state.patientOrders || [];
    const firstPatient =
      (patientOrders[0] && patientOrders[0].patient) ||
      (carts[0] && carts[0].patient) ||
      {};
    // Same fields the server reads from an order line: the lab, test,
    // category and package ids, the selling price, and THIS line's patient.
    const idOf = (v) => (v && typeof v === 'object' ? v.id : v) || null;
    const items = carts.map((c) => {
      const isPackage = c.order_type === 'package';
      const ti = isPackage ? c.package && c.package.test_item : c.test_item;
      const test = ti && ti.diagnostic_test;
      const lab = ti && ti.branch && ti.branch.lab;
      const patient = c.patient || {};
      return {
        lab_id: idOf(lab),
        test_id: idOf(test),
        category_id: test && typeof test === 'object' ? idOf(test.category) : null,
        // A cart package is the lab's package item; its `package` is the
        // package id the server matches campaigns on.
        package_id: isPackage ? idOf(c.package && c.package.package) || idOf(c.package) : null,
        price:
          ti && ti.purchasable_order_item ? ti.purchasable_order_item.sell_price : 0,
        patient: {
          sex: patient.sex || patient.gender || '',
          dob: patient.dob || patient.date_of_birth || null,
        },
      };
    });

    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/diagnostic/brand-discount/evaluate_cart/`,
        {
          items: items,
          patient: {
            sex: firstPatient.gender || firstPatient.sex || '',
            dob: firstPatient.date_of_birth || firstPatient.dob || null,
          },
        }
      )
      .then((res) => {
        if (res.data && res.data.matched && res.data.brand_discount) {
          this.setState({ brandDiscount: res.data.brand_discount });
        } else {
          this.setState({ brandDiscount: null });
        }
      })
      .catch(() => {
        this.setState({ brandDiscount: null });
      });
  };

  // The discount the order will get, decided like the server does
  // (order/secure_checkout.py compute_order_discount): a stackable campaign is
  // added on top of coupon + lab discount; otherwise the larger of campaign vs
  // (coupon + lab) wins, ties to the campaign.
  // Collection / material fee the winning campaign makes free (the server
  // records it on the order discount and leaves it out of the payment).
  // A non-stackable campaign that beats the coupon / lab discount replaces
  // them, their fee waivers included (as on the server).
  brandReplacesOthers = () => {
    const bd = this.state.brandDiscount;
    const brand = bd ? parseInt(bd.discount_amount, 10) || 0 : 0;
    const couponLab = (this.state.discountAmount || 0) + (this.state.labDiscount || 0);
    return brand > 0 && !bd.can_stack_with_coupon && couponLab > 0 && brand >= couponLab;
  };

  // The collection fee the order is charged before the campaign's own waiver.
  shownCollectionFee = () => {
    if (!this.brandReplacesOthers()) return this.state.fees.collection_fee;
    const api = this.state.feesApi || {};
    const coll = parseInt(api.collection_fee, 10) || 0;
    return this.state.deliveryCopy === 'soft' ? coll : coll + (parseInt(api.delivery_fee, 10) || 0);
  };

  brandWaivedFees = () => {
    const bd = this.state.brandDiscount;
    if (!bd) return 0;
    const carts = this.state.carts || [];
    const collection = bd.waive_collection_fee ? parseInt(this.shownCollectionFee(), 10) || 0 : 0;
    const material = bd.waive_material_fee ? parseInt(this.getGroupedMaterialFeeTotal(carts), 10) || 0 : 0;
    return collection + material;
  };

  brandOutcome = () => {
    const couponLab = (this.state.discountAmount || 0) + (this.state.labDiscount || 0);
    const bd = this.state.brandDiscount;
    const brand = bd ? parseInt(bd.discount_amount, 10) || 0 : 0;
    if (brand <= 0) {
      return { total: couponLab, brandApplied: false, replacesOthers: false, waived: 0 };
    }
    if (bd.can_stack_with_coupon) {
      return { total: couponLab + brand, brandApplied: true, replacesOthers: false, waived: this.brandWaivedFees() };
    }
    if (brand >= couponLab) {
      return { total: brand, brandApplied: true, replacesOthers: couponLab > 0, waived: this.brandWaivedFees() };
    }
    return { total: couponLab, brandApplied: false, replacesOthers: false, waived: 0 };
  };

  userOrderCheck = (id) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/order/user-order-exist/${id}`)
      .then((resp) => {
        this.setState(
          {
            ifUserOrder: resp.data.exist ? 'old' : 'new',
          },
          () => {
            if (this.state.carts && this.state.carts.length !== 0) {
              this.getLabDiscount();
            }
          }
        );
        // console.log(resp.data);
      })
      .catch((error) => {});
  };

  isLabDiscountAllowedForUser = (coupon) => {
    if (!coupon) return false;
    if (this.state.ifUserOrder !== 'old') return true;
    return coupon.new_user_only !== true;
  };

  getEligibleLabDiscounts = (discounts = []) => {
    if (!Array.isArray(discounts)) return [];
    return discounts.filter((coupon) =>
      this.isLabDiscountAllowedForUser(coupon)
    );
  };

  serviceFeesRemove = (array) => {
    const testItems = array
      .filter((item) => {
        return item.order_type === 'diagnostic';
      })
      .map((item) => {
        return item.test_item.diagnostic_test.name;
      });

    const checkOne = testItems.includes('Covid RT PCR');
    const checkTwo = testItems.includes('Covid Antigen');

    // console.log(checkTwo);
    if (checkOne || checkTwo) {
      this.setState({
        fees: { meterial_fee: 0, collection_fee: 0, delivery_fee: 0 },
      });
    } else if (array && array.length && array[0].order_type === 'package') {
      this.setState({
        fees: { meterial_fee: 0, collection_fee: 0, delivery_fee: 0 },
      });
    }
  };

  calculateLabDiscount = (array) => {
    // console.log(array);
    // console.log(this.state.carts);
    const eligibleDiscounts = this.getEligibleLabDiscounts(array);
    if (eligibleDiscounts.length === 0) {
      this.setState({ labDiscount: null, labDisLoading: false });
      return;
    }

    let labMatched = false;

    this.state.carts.forEach((test) => {
      let matchedLabs = [];
      if (test.order_type === 'diagnostic') {
        const matched = eligibleDiscounts.find((coupon) => {
          return (
            test.test_item.branch.lab.name.toLowerCase() ===
            coupon.lab.name.toLowerCase()
          );
        });
        if (matched) {
          matchedLabs.push(matched);
        }
      } else if (test.order_type === 'package') {
        const matched = eligibleDiscounts.find((coupon) => {
          return (
            test.package.test_item.branch.lab.name.toLowerCase() ===
            coupon.lab.name.toLowerCase()
          );
        });
        if (matched) {
          matchedLabs.push(matched);
        }
      }

      if (matchedLabs.length !== 0) {
        labMatched = true;
      }
    });

    if (labMatched) {
      // console.log('continue for next step');

      let matchedTests = [];
      let matchedPackages = [];

      eligibleDiscounts.forEach((labTest) => {
        let single = [];
        labTest.cct_lab.forEach((test) => {
          let existing = this.state.carts
            .filter((cart) => cart.order_type === 'diagnostic')
            .filter(
              (cart) =>
                cart.test_item.diagnostic_test.id === test.test.id &&
                cart.test_item.branch.lab.id === labTest.lab.id
            )
            .map((cart) => {
              return {
                ...cart,
                criteria: labTest.criteria,
                rate: labTest.rate,
                is_collection_fee: labTest.is_collection_fee,
                is_material_fee: labTest.is_material_fee,
                material_rate_percentage: labTest.material_rate_percentage,
              };
            });

          if (existing) {
            single.push(...existing);
          }
        });
        matchedTests.push(...single);
      });
      eligibleDiscounts.forEach((labTest) => {
        let single = [];
        labTest.ccp_lab.forEach((test) => {
          let existing = this.state.carts
            .filter((cart) => cart.order_type === 'package')
            .filter(
              (cart) =>
                cart.package.package.id === test.package.id &&
                cart.package.test_item.branch.lab.id === labTest.lab.id
            )
            .map((cart) => {
              return {
                ...cart,
                criteria: labTest.criteria,
                rate: labTest.rate,
                is_collection_fee: labTest.is_collection_fee,
                is_material_fee: labTest.is_material_fee,
                material_rate_percentage: labTest.material_rate_percentage,
              };
            });

          if (existing) {
            single.push(...existing);
          }
        });
        matchedPackages.push(...single);
      });

      // const testIds = matchedTests.map((o) => o.test_item.id);
      // matchedTests = matchedTests.filter(
      //   (item, index) => !testIds.includes(item.test_item.id, index + 1)
      // );

      matchedTests = matchedTests.filter(
        (tag, index, array) =>
          array.findIndex(
            (t) =>
              t.test_item.id === tag.test_item.id &&
              t.patient.id === tag.patient.id
          ) === index
      );

      // const packageIds = matchedPackages.map((o) => o.package.test_item.id);
      // matchedPackages = matchedPackages.filter(
      //   (item, index) =>
      //     !packageIds.includes(item.package.test_item.id, index + 1)
      // );

      matchedPackages = matchedPackages.filter(
        (tag, index, array) =>
          array.findIndex(
            (t) =>
              t.package.test_item.id === tag.package.test_item.id &&
              t.patient.id === tag.patient.id
          ) === index
      );

      const allItems = [...matchedTests, ...matchedPackages];
      // console.log(allItems);

      let itemMaterial = 0,
        itemColletion = 0;

      const checkCollection = allItems.map((item) => item.is_collection_fee);
      checkCollection.includes(true)
        ? (itemColletion = 0)
        : (itemColletion = this.state.fees.collection_fee);

      const checkMaterial = allItems
        .filter((item) => {
          return item.is_material_fee;
        })
        .sort(
          (a, b) =>
            parseFloat(b.material_rate_percentage) -
            parseFloat(a.material_rate_percentage)
        );
      if (checkMaterial.length !== 0) {
        // console.log(checkMaterial[0]);
        itemMaterial =
          this.state.fees.meterial_fee -
          (this.state.fees.meterial_fee *
            checkMaterial[0].material_rate_percentage) /
            100;
      } else {
        itemMaterial = this.state.fees.meterial_fee;
      }

      // console.log(itemColletion, itemMaterial);
      this.setState({
        fees: { meterial_fee: itemMaterial, collection_fee: itemColletion },
      });
      setTimeout(() => {
        this.serviceFeesRemove(this.state.carts);
      }, 300);

      // console.log(this.state.carts);
      const newCart = this.state.carts.map((cart) => {
        const matched = matchedTests.find(
          (test) =>
            test.patient === cart.patient && test.test_item === cart.test_item
        );
        // copy the match so duplicate rows never share one object reference
        return matched ? { ...matched } : cart;
      });
      // console.log(newCart);
      this.setState({ carts: newCart });
      setTimeout(() => {
        this.serviceFeesRemove(this.state.carts);
      }, 300);

      const newCart1 = this.state.carts.map((cart) => {
        const matched = matchedPackages.find(
          (test) => test.patient === cart.patient && test.package === cart.package
        );
        // copy the match so duplicate rows never share one object reference
        return matched ? { ...matched } : cart;
      });
      // console.log(newCart1);
      this.setState({ carts: newCart1 });
      setTimeout(() => {
        this.serviceFeesRemove(this.state.carts);
      }, 300);

      const discountTestPrice = matchedTests.reduce((total, item) => {
        if (item.criteria === 'perchantange') {
          return (
            total +
            (parseInt(item.test_item.purchasable_order_item.sell_price) *
              parseInt(item.rate)) /
              100
          );
        } else {
          return total + parseInt(item.rate);
        }
      }, 0);

      const discountPackagePrice = matchedPackages.reduce((total, item) => {
        if (item.criteria === 'perchantange') {
          return (
            total +
            (parseInt(item.package.package.purchasable_order_item.sell_price) *
              parseInt(item.rate)) /
              100
          );
        } else {
          return total + parseInt(item.rate);
        }
      }, 0);

      const discountPrice = discountTestPrice + discountPackagePrice;

      if (discountPrice && 0 < discountPrice) {
        this.setState({ labDiscount: discountPrice });
        // console.log(discountTestPrice);
      } else {
        this.setState({ labDiscount: null });
      }
    } else {
      this.setState({ labDiscount: null });
    }

    this.setState({ labDisLoading: false });
  };

  getLabDiscount = () => {
    this.setState({ labDisLoading: true });
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/diagnostic/lab-discount-get/`)
      .then((resp) => {
        // console.log(resp.data.results);
        // this.calculateLabDiscount(resp.data.results);
        if (resp.data.results.length !== 0) {
          const data = resp.data.results
            .filter((coupon) => coupon.is_active)
            .filter((coupon) => {
              const expire_day = moment(coupon.expired_at)
                .add(1, 'days')
                .format('YYYY-MM-DD')
                .toString();
              const isSameOrAfter = moment(expire_day).isSameOrAfter(
                this.state.today
              );

              if (isSameOrAfter) {
                return coupon;
              }
            })
            .filter((coupon) => this.isLabDiscountAllowedForUser(coupon));

          this.calculateLabDiscount(data);
        } else {
          this.setState({ labDiscount: null });
        }
        this.setState({ labDisLoading: false });
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({ labDisLoading: false });
      });
  };

  selectSavedAddress = (selectedAddr) => {
    let newSelectLoopItem = [...dhakaArea];
    if (selectedAddr.district === 'Dhaka') {
      newSelectLoopItem = [...dhakaArea];
    } else if (selectedAddr.district === 'Savar') {
      newSelectLoopItem = [...savarArea];
    } else if (selectedAddr.district === 'Chattogram') {
      newSelectLoopItem = [...ctgArea];
    }

    if (selectedAddr.thana && !newSelectLoopItem.includes(selectedAddr.thana)) {
      newSelectLoopItem = [selectedAddr.thana, ...newSelectLoopItem];
    }

    this.setState({
      district: selectedAddr.district || 'Dhaka',
      thana: selectedAddr.thana || '',
      address: selectedAddr.address || '',
      mobile: selectedAddr.mobile || this.state.mobile || '',
      email: selectedAddr.email || this.state.email || '',
      addressId: selectedAddr.id,
      selectLoopItem: newSelectLoopItem,
      locationLoopItem: newSelectLoopItem,
    });
  };

  fetchUserAddress = async (patientId) => {
    let userId = this.context.userId;
    if (!userId) {
      const raw = localStorage.getItem('user_id');
      if (raw) {
        try {
          userId = JSON.parse(raw);
        } catch (e) {
          userId = raw;
        }
      }
    }

    const patId = patientId || (this.context.suMyself && this.context.suMyself.length > 0 ? this.context.suMyself[0].id : null);

    let combined = [];
    let seen = new Set();

    if (userId) {
      try {
        const userResp = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/user_management/address/?user=${userId}&status=true&ordering=-id`
        );
        if (userResp.data && userResp.data.results) {
          userResp.data.results.forEach((addr) => {
            if (addr.status && !seen.has(addr.id)) {
              seen.add(addr.id);
              combined.push(addr);
            }
          });
        }
      } catch (e) {}
    }

    if (patId) {
      try {
        const patResp = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/user_management/address/?patient=${patId}&status=true&ordering=-id`
        );
        if (patResp.data && patResp.data.results) {
          patResp.data.results.forEach((addr) => {
            if (addr.status && !seen.has(addr.id)) {
              seen.add(addr.id);
              combined.push(addr);
            }
          });
        }
      } catch (e) {}
    }

    combined.sort((a, b) => b.id - a.id);
    const top2Addresses = combined.slice(0, 2);
    this.setState({ userAddresses: top2Addresses });

    if (top2Addresses.length !== 0) {
      this.selectSavedAddress(top2Addresses[0]);
    } else {
      this.setState({ district: this.context.navAreaName });
      if (this.context.navAreaName === 'Dhaka') {
        this.setState({ selectLoopItem: dhakaArea, locationLoopItem: dhakaArea });
      } else if (this.context.navAreaName === 'Savar') {
        this.setState({ selectLoopItem: savarArea, locationLoopItem: savarArea });
      } else if (this.context.navAreaName === 'Chattogram') {
        this.setState({ selectLoopItem: ctgArea, locationLoopItem: ctgArea });
      }
    }
  };

  componentDidMount() {
    console.log(this.props.location.params);

    this.context.setPageTitle('Checkout');
    window.scrollTo(0, 0);
    const getCarts = localStorage.getItem('order');
    const userId = localStorage.getItem('user_id');
    const userPatient = localStorage.getItem('userPatients');

    const token = localStorage.getItem('token');
    !token ? this.props.history.push('/login') : console.log('');

    this.context.setInterceptors(JSON.parse(token));

    if (getCarts && userId) {
      if (
        this.props.location &&
        this.props.location.params &&
        this.props.location.params.carts
      ) {
        const allCarts = JSON.parse(getCarts);
        this.setState({ user: allCarts.user });
        if (allCarts.user.pk === JSON.parse(userId)) {
          if (allCarts.order_item.length === 0) {
            this.props.history.push('/');
          }

          const price = this.getTotalPrice(this.props.location.params.carts);
          // console.log(price);
          this.setState({ subTotal: price });
          this.userOrderCheck(JSON.parse(userId));
          this.setState({ mobile: allCarts.user.username });
          this.handleMeterialPerson(this.props.location.params.carts);

          this.setState(
            { carts: this.props.location.params.carts },
            () => {
              this.getLabDiscount();
              this.evaluateBrandDiscount(this.props.location.params.carts);
            }
          );
          this.getFees(this.props.location.params.carts);

          if (
            this.props.location &&
            this.props.location.params &&
            this.props.location.params.labDiscount
          ) {
            this.setState({
              labDiscount: this.props.location.params.labDiscount,
            });
          }

          if (
            this.props.location &&
            this.props.location.params &&
            this.props.location.params.discountAmount
          ) {
            this.setState({
              discountAmount: this.props.location.params.discountAmount,
            });
          }

          if (
            this.props.location &&
            this.props.location.params &&
            this.props.location.params.showDiscount
          ) {
            this.setState({
              showDiscount: this.props.location.params.showDiscount,
            });
          }

          if (
            this.props.location &&
            this.props.location.params &&
            this.props.location.params.coupon
          ) {
            this.setState({
              coupon: this.props.location.params.coupon,
              // Without the id the order was saved with cupon: null - the
              // discount went through, but not which coupon gave it, so coupon
              // usage and reporting could not see it.
              cuponId: this.props.location.params.cuponId || null,
            });
          }

        }
      } else {
        this.props.history.push('/cart');
      }

      if (userPatient) {
        const parUserPatient = JSON.parse(userPatient);
        // console.log(parUserPatient);
        if (parUserPatient && parUserPatient.length !== 0) {
          this.fetchUserAddress(parUserPatient[0].id);
        } else {
          this.fetchUserAddress(null);
        }
      } else {
        this.fetchUserAddress(null);
      }
    } else {
      this.getFees([]);
    }
  }

  setDefaultDate = (params) => {
    this.setState({ date: params });
  };

  handleSelect = (e) => {
    const val = e.target.value;
    let areas = [...dhakaArea];
    if (val === 'Dhaka') {
      areas = [...dhakaArea];
    } else if (val === 'Savar') {
      areas = [...savarArea];
    } else if (val === 'Chattogram') {
      areas = [...ctgArea];
    }
    this.setState({
      district: val,
      thana: '',
      selectLoopItem: areas,
      locationLoopItem: areas,
    });
  };

  getTotalPrice = (array) => {
    const diagnosticrr = array.filter((diag) => {
      return diag.order_type === 'diagnostic';
    });

    const packagerr = array.filter((diag) => {
      return diag.order_type === 'package';
    });

    const diagprice = diagnosticrr.reduce(
      (total, item) =>
        total + parseInt(item.test_item.purchasable_order_item.sell_price),
      0
    );

    const packprice = packagerr.reduce(
      (total, item) =>
        total +
        parseInt(item.package.test_item.purchasable_order_item.sell_price),
      0
    );

    return diagprice + packprice;
  };

  getTotalPriceWithFees = (array) => {
    const diagnosticrr = array.filter((diag) => {
      return diag.order_type === 'diagnostic';
    });

    const packagerr = array.filter((diag) => {
      return diag.order_type === 'package';
    });

    const diagprice = diagnosticrr.reduce(
      (total, item) =>
        total + parseInt(item.test_item.purchasable_order_item.sell_price),
      0
    );

    const packprice = packagerr.reduce(
      (total, item) =>
        total +
        parseInt(item.package.test_item.purchasable_order_item.sell_price),
      0
    );
    const totalPrice =
      diagprice +
      packprice +
      this.shownCollectionFee() +
      this.getGroupedMaterialFeeTotal(array);
    return totalPrice;
  };

  getTotalPriceWithFeesWithCoupon = (array) => {
    const diagnosticrr = array.filter((diag) => {
      return diag.order_type === 'diagnostic';
    });

    const packagerr = array.filter((diag) => {
      return diag.order_type === 'package';
    });

    const diagprice = diagnosticrr.reduce(
      (total, item) =>
        total + parseInt(item.test_item.purchasable_order_item.sell_price),
      0
    );

    const packprice = packagerr.reduce(
      (total, item) =>
        total +
        parseInt(item.package.test_item.purchasable_order_item.sell_price),
      0
    );
    const totalPrice =
      diagprice +
      packprice +
      this.shownCollectionFee() +
      this.getGroupedMaterialFeeTotal(array);
    const outcome = this.brandOutcome();
    const discountToDeduct = outcome.total + (outcome.waived || 0);
    return Math.max(0, totalPrice - discountToDeduct);
  };

  // getTotalPrice = (array) => {
  //   return array.reduce(
  //     (total, item) =>
  //       total + parseInt(item.test_item.purchasable_order_item.sell_price),
  //     0
  //   );
  // };

  getDefaultFeeConfig = () => ({
    id: null,
    created_at: null,
    meterial_fee: 0,
    collection_fee: 0,
    collection_fee_extend: 0,
    delivery_fee: 0,
    inactive_test: false,
    test: null,
  });

  normalizeFeeConfig = (feeData = {}) => {
    const feeTestId =
      feeData && feeData.test && typeof feeData.test === 'object'
        ? parseInt(feeData.test.id)
        : feeData && feeData.test
          ? parseInt(feeData.test)
          : null;

    return {
      ...this.getDefaultFeeConfig(),
      ...feeData,
      id: feeData && feeData.id ? parseInt(feeData.id) : null,
      meterial_fee: parseInt(feeData.meterial_fee) || 0,
      collection_fee: parseInt(feeData.collection_fee) || 0,
      collection_fee_extend: parseInt(feeData.collection_fee_extend) || 0,
      delivery_fee: parseInt(feeData.delivery_fee) || 0,
      inactive_test:
        typeof feeData.inactive_test === 'boolean'
          ? feeData.inactive_test
          : false,
      test: feeTestId,
      created_at: feeData && feeData.created_at ? feeData.created_at : null,
    };
  };

  getFeeConfigsFromApi = (resp) => {
    const feeRows =
      resp &&
      resp.data &&
      Array.isArray(resp.data.results)
        ? resp.data.results
        : resp && resp.data && Array.isArray(resp.data)
          ? resp.data
          : [];

    if (!feeRows.length) {
      return [this.getDefaultFeeConfig()];
    }

    return feeRows
      .map((item) => this.normalizeFeeConfig(item))
      .sort((a, b) => {
        const dateA = new Date(a.created_at || 0).getTime();
        const dateB = new Date(b.created_at || 0).getTime();
        if (dateA !== dateB) {
          return dateB - dateA;
        }
        return (b.id || 0) - (a.id || 0);
      });
  };

  getCartTestMeta = (cart = {}) => {
    if (!cart) {
      return { testId: null, isActive: null };
    }

    if (cart.order_type === 'diagnostic') {
      const testItem = cart.test_item || null;
      const diagnosticTest =
        testItem && testItem.diagnostic_test ? testItem.diagnostic_test : null;
      return {
        testId: diagnosticTest && diagnosticTest.id ? parseInt(diagnosticTest.id) : null,
        isActive:
          diagnosticTest && typeof diagnosticTest.is_active === 'boolean'
            ? diagnosticTest.is_active
            : testItem && typeof testItem.is_active === 'boolean'
              ? testItem.is_active
              : null,
      };
    }

    if (cart.order_type === 'package') {
      const packageTestItem =
        cart && cart.package && cart.package.test_item ? cart.package.test_item : null;
      const diagnosticTest =
        packageTestItem && packageTestItem.diagnostic_test
          ? packageTestItem.diagnostic_test
          : null;
      return {
        testId: diagnosticTest && diagnosticTest.id ? parseInt(diagnosticTest.id) : null,
        isActive:
          diagnosticTest && typeof diagnosticTest.is_active === 'boolean'
            ? diagnosticTest.is_active
            : packageTestItem && typeof packageTestItem.is_active === 'boolean'
              ? packageTestItem.is_active
              : null,
      };
    }

    return { testId: null, isActive: null };
  };

  isConditionalFeeMatchedInCarts = (carts = [], feeConfig = {}) => {
    if (!carts || carts.length === 0) {
      return false;
    }

    const targetTestStatus = feeConfig.inactive_test ? false : true;
    const targetTestId = feeConfig.test ? parseInt(feeConfig.test) : null;

    return carts.some((cart) => {
      const meta = this.getCartTestMeta(cart);
      if (typeof meta.isActive !== 'boolean') {
        return false;
      }
      if (meta.isActive !== targetTestStatus) {
        return false;
      }
      if (targetTestId) {
        return meta.testId === targetTestId;
      }
      return true;
    });
  };

  getBaseCollectionFee = (feeConfig = {}, isConditionMatched = false) => {
    const normalFee = parseInt(feeConfig.collection_fee) || 0;
    const extendedFee = parseInt(feeConfig.collection_fee_extend) || 0;
    const hasExtendedFee = extendedFee > 0;
    if (!hasExtendedFee) {
      return normalFee;
    }
    return isConditionMatched ? extendedFee : normalFee;
  };

  getPrioritizedFeeRule = (rules = [], carts = []) => {
    if (!rules.length) {
      return this.getDefaultFeeConfig();
    }
    if (!carts.length) {
      const latestGenericRule = rules.find((rule) => !rule.test && !rule.inactive_lab);
      if (latestGenericRule) {
        return latestGenericRule;
      }
      return this.getDefaultFeeConfig();
    }

    const includeDelivery = this.state.deliveryCopy !== 'soft';
    const getRulePriorityAmount = (rule = {}) => {
      const baseCollectionFee = this.getBaseCollectionFee(rule, true);
      const deliveryFee = parseInt(rule.delivery_fee) || 0;
      return includeDelivery ? baseCollectionFee + deliveryFee : baseCollectionFee;
    };

    const pickHighestPricedRule = (matchedRules = []) => {
      if (!matchedRules.length) {
        return null;
      }
      return matchedRules.reduce((bestRule, currentRule) => {
        if (!bestRule) {
          return currentRule;
        }
        const bestAmount = getRulePriorityAmount(bestRule);
        const currentAmount = getRulePriorityAmount(currentRule);
        if (currentAmount > bestAmount) {
          return currentRule;
        }
        return bestRule;
      }, matchedRules[0]);
    };

    const matchedSpecificRules = rules.filter(
      (rule) =>
        !!rule.test && this.isConditionalFeeMatchedInCarts(carts, rule)
    );
    const bestSpecificRule = pickHighestPricedRule(matchedSpecificRules);
    if (bestSpecificRule) {
      return bestSpecificRule;
    }

    const matchedGenericRules = rules.filter(
      (rule) =>
        !rule.test && this.isConditionalFeeMatchedInCarts(carts, rule)
    );
    const bestGenericRule = pickHighestPricedRule(matchedGenericRules);
    if (bestGenericRule) {
      return bestGenericRule;
    }

    const latestGenericRule = rules.find((rule) => !rule.test);
    if (latestGenericRule) {
      return latestGenericRule;
    }

    return this.getDefaultFeeConfig();
  };

  // Material fee rate that applies to one patient, based only on that
  // patient's own tests (reuses the existing rule-matching engine, just
  // scoped to one patient instead of the whole cart).
  //
  // rulesOverride: pass an explicitly freshly-fetched rules array (see
  // fetchFreshFeeRulesForSubmit) to bypass this.state.feeRules, which may be
  // stale if the tab has been open since before an admin changed the fee
  // table or since before a fix was deployed.
  getMaterialFeeForItems = (items = [], rulesOverride = null) => {
    const rule = this.getPrioritizedFeeRule(rulesOverride || this.state.feeRules || [], items);
    return parseInt(rule.meterial_fee) || 0;
  };

  // Order-wide material fee total: each distinct patient's own rate, summed
  // once per patient (not once per test item).
  getGroupedMaterialFeeTotal = (carts = [], rulesOverride = null) => {
    const groups = {};
    (carts || []).forEach((cart) => {
      const patientId = cart && cart.patient && cart.patient.id;
      if (patientId == null) return;
      if (!groups[patientId]) {
        groups[patientId] = [];
      }
      groups[patientId].push(cart);
    });
    return Object.keys(groups).reduce(
      (total, patientId) => total + this.getMaterialFeeForItems(groups[patientId], rulesOverride),
      0
    );
  };

  // Re-fetches the fee table fresh, right before an order is actually
  // submitted, and returns { feeRules, collectionFee } WITHOUT relying on
  // this.state having updated in time (setState is async/batched). Guards
  // against a browser tab that has been open since before an admin changed a
  // fee row or since before a fix was deployed — checkout must always price
  // using the fee table as it is at the moment of payment, not whatever was
  // current when the page first loaded. Mirrors getFees()'s own collection-
  // fee computation so the two never disagree. Falls back to whatever is
  // already in state if the network call fails, so a transient error here
  // never blocks order placement.
  fetchFreshFeeRulesForSubmit = async () => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/diagnostic/fees/?limit=200`
      );
      const feeRules = this.getFeeConfigsFromApi(resp);
      const targetCarts = this.state.carts || [];
      const selectedRule = this.getPrioritizedFeeRule(feeRules, targetCarts);
      const isConditionMatched = this.isConditionalFeeMatchedInCarts(targetCarts, selectedRule);
      const baseCollectionFee = this.getBaseCollectionFee(selectedRule, isConditionMatched);
      const collectionFee =
        this.state.deliveryCopy === 'soft'
          ? baseCollectionFee
          : baseCollectionFee + (parseInt(selectedRule.delivery_fee) || 0);
      this.setState({ feeRules, fees: { ...this.state.fees, collection_fee: collectionFee } });
      return { feeRules, collectionFee };
    } catch (e) {
      return { feeRules: this.state.feeRules || [], collectionFee: this.state.fees.collection_fee };
    }
  };

  deleteItem = (i, item, setCartsItem, setIsLocalLab) => {
    this.context.postActivity(
      'button',
      `Remove Cart (${
        item.order_type === 'diagnostic'
          ? item.test_item.diagnostic_test.name
          : item.package.test_item.diagnostic_test.name
      })`,
      window.location.href
    );
    const filter = this.state.carts.filter((singel) => singel !== item);

    setCartsItem(filter);
    this.setState({ carts: filter });
    const price = this.getTotalPriceWithFees(filter);
    this.setState({ subTotal: price });

    const newData = {
      user: this.state.user,
      status: '',
      order_item: filter,
    };

    localStorage.removeItem('order');
    localStorage.setItem('order', JSON.stringify(newData));

    if (filter.length === 0) {
      localStorage.removeItem('lab_name');
      localStorage.removeItem('lab_location');
      setIsLocalLab(false);
    }

    this.handleMeterialPerson(filter);
    this.getFees(filter);
  };

  getFees = (carts = null) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/diagnostic/fees/?limit=200`)
      .then((resp) => {
        const feeRules = this.getFeeConfigsFromApi(resp);
        const targetCarts = carts || this.state.carts || [];
        const selectedRule = this.getPrioritizedFeeRule(feeRules, targetCarts);
        const isConditionMatched = this.isConditionalFeeMatchedInCarts(
          targetCarts,
          selectedRule
        );
        const baseCollectionFee = this.getBaseCollectionFee(
          selectedRule,
          isConditionMatched
        );
        const normalizedFeeConfig = {
          ...selectedRule,
          collection_fee: baseCollectionFee,
        };
        const totalCollectionFee =
          this.state.deliveryCopy === 'soft'
            ? baseCollectionFee
            : baseCollectionFee + normalizedFeeConfig.delivery_fee;

        this.setState({
          feesApi: normalizedFeeConfig,
          feeRules,
          fees: {
            collection_fee: totalCollectionFee,
            meterial_fee: normalizedFeeConfig.meterial_fee,
            delivery_fee: normalizedFeeConfig.delivery_fee,
          },
        });
        setTimeout(() => {
          this.serviceFeesRemove(targetCarts);
        }, 300);
      })
      .catch((error) => {});
  };

  postReference = (postData) => {
    return axios.post(
      `${process.env.REACT_APP_BASE_URL}/order/order-detail/`,
      postData
    );
  };

  postDiscount = (postData) => {
    return axios.post(
      `${process.env.REACT_APP_BASE_URL}/order/order-discount/`,
      postData
    );
  };

  orderItemDiscountPrice = (item) => {
    if (item.rate && item.criteria) {
      if (item.order_type === 'diagnostic') {
        if (item.criteria === 'perchantange') {
          return (
            (parseInt(item.test_item.purchasable_order_item.sell_price) *
              item.rate) /
            100
          );
        } else if (item.criteria === 'static') {
          return (
            parseInt(item.test_item.purchasable_order_item.sell_price) -
            item.rate
          );
        }
      } else if (item.order_type === 'package') {
        if (item.criteria === 'perchantange') {
          return (
            (parseInt(
              item.package.test_item.purchasable_order_item.sell_price
            ) *
              item.rate) /
            100
          );
        } else if (item.criteria === 'static') {
          return (
            parseInt(item.package.test_item.purchasable_order_item.sell_price) -
            item.rate
          );
        }
      }
    } else {
      return 0;
    }
  };

  postDeliverySoft = (id) => {
    const isSoftNeeded =
      this.state.deliveryCopy === 'both' || this.state.deliveryCopy === 'soft';
    const postDate = {
      order: id,
      name: isSoftNeeded ? 'soft_copy_due' : 'no_soft_copy',
    };

    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/order/order-report-delivery-status/`,
        postDate
      )
      .then((resp) => {
        // console.log(resp.data);
      })
      .catch((error) => {
        // console.log(error.response);
      });
  };

  postDeliveryHard = (id) => {
    const isHardNeeded =
      this.state.deliveryCopy === 'both' || this.state.deliveryCopy === 'hard';
    const postDate = {
      order: id,
      name: isHardNeeded ? 'hard_copy_due' : 'no_hard_copy',
    };

    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/order/order-report-hardcopy-delivery-status/`,
        postDate
      )
      .then((resp) => {
        // console.log(resp.data);
      })
      .catch((error) => {
        // console.log(error.response);
      });
  };

  smsApiCall = (orderId, status) => {
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/order/sms-order-status/${orderId}/${status}`
      )
      .then((resp) => {
        // console.log('come success', resp.data);
      })
      .catch((error) => {
        // console.log('come err', error.response);
      });
  };

  postOrderAndDetails = async (addressId) => {
    // Fetch the fee table fresh right now, at the moment of actual
    // submission — never trust this.state.feeRules here, since the tab may
    // have been open since before the fee table (or a pricing fix) changed.
    const { feeRules: freshFeeRules, collectionFee: freshCollectionFee } =
      await this.fetchFreshFeeRulesForSubmit();
    const order_items = this.state.carts.map((cart) => {
      const patientCarts = this.state.carts.filter(
        (c) => c && c.patient && cart.patient && c.patient.id === cart.patient.id
      );
      return {
        patient: cart.patient.id,
        address: addressId,
        order_type: cart.order_type,
        // This patient's own material fee, based on their own tests (not one
        // shared value for the whole order).
        meterial_fee: this.getMaterialFeeForItems(patientCarts, freshFeeRules),
        cupon: this.state.cuponId ? this.state.cuponId : null,
        price:
          cart.order_type === 'diagnostic'
            ? parseInt(cart.test_item.purchasable_order_item.sell_price)
            : parseInt(
                cart.package.test_item.purchasable_order_item.sell_price
              ),
        purchasable_order_item:
          cart.order_type === 'diagnostic'
            ? cart.test_item.purchasable_order_item.id
            : cart.package.test_item.purchasable_order_item.id,
        discount_price: this.orderItemDiscountPrice(cart),
      };
    });

    const covidOrNot = this.state.carts.map((cart) => {
      return cart.order_type === 'diagnostic'
        ? cart.test_item.diagnostic_test.is_covid
        : cart.package.test_item.diagnostic_test.is_covid;
    });

    const postOrder = {
      user: this.state.user.pk,
      // status: 'order_confirmed',
      date: moment(this.state.date).format('YYYY-MM-DD'),
      orderitem: order_items,
      total_price: this.getTotalPrice(this.state.carts),
      collection_fee: freshCollectionFee,
      material_fee: this.getGroupedMaterialFeeTotal(this.state.carts, freshFeeRules),
      order_type: covidOrNot.includes(true) ? 'covid' : 'non_covid',
    };

    // console.log(postOrder);

    axios
      .post(`${process.env.REACT_APP_BASE_URL}/order/order/`, postOrder)
      .then((resp) => {
        this.context.setLastCartPatient([]);
        localStorage.removeItem('lastCartPatient');
        // console.log(resp.data);
        this.postDeliverySoft(resp.data.orderitem[0].order);
        this.postDeliveryHard(resp.data.orderitem[0].order);

        this.smsApiCall(resp.data.orderitem[0].order, 'order_placement');

        this.context.postActivity(
          'order',
          resp.data.orderitem[0].order,
          window.location.href
        );

        const postOrderDetails = {
          references: this.state.reference ? this.state.reference : null,
          order: resp.data.orderitem[0].order,
          address: addressId,
          user_type: this.state.ifUserOrder,
          delivery_copy_status: this.state.deliveryCopy,
        };
        const refPromise = this.postReference(postOrderDetails).catch((e) => {
          console.error('postReference error', e);
        });



        const mainCollFee =
          this.state.deliveryCopy === 'soft'
            ? this.state.feesApi.collection_fee
            : this.state.feesApi.collection_fee +
              this.state.feesApi.delivery_fee;

        const outcome = this.brandOutcome();
        const brandDis = outcome.brandApplied ? this.state.brandDiscount : null;

        const postOrderDiscount = {
          order: resp.data.orderitem[0].order,
          cupon: this.state.cuponId,
          // The server re-validates the coupon from its code; with only the id
          // it cannot tell a real code from a guessed id.
          cupon_code: this.state.coupon ? String(this.state.coupon).trim() : null,
          brand_discount: brandDis ? brandDis.id : null,
          discount_note: brandDis
            ? `${brandDis.name}${brandDis.reason ? ': ' + brandDis.reason : ''}`
            : 'Frontend coupon',
          discount_price: outcome.total,
          discount_source: brandDis ? 'brand_discount' : 'cupon',
          collection_discount_price:
            mainCollFee - this.state.fees.collection_fee,
          material_discount_price:
            (parseInt(this.state.feesApi.meterial_fee) || 0) *
            this.state.materialPerson -
            this.state.fees.meterial_fee * this.state.materialPerson,
        };

        const discPromise = (this.state.discountAmount || this.state.labDiscount || brandDis)
          ? this.postDiscount(postOrderDiscount).catch((e) => {
              console.error('postDiscount error', e);
            })
          : Promise.resolve();

        Promise.allSettled([refPromise, discPromise]).then(() => {
          toast.success('Your order has been successfully placed.', {
            autoClose: 3000,
          });
          localStorage.removeItem('order');
          localStorage.removeItem('lab_name');
          localStorage.removeItem('lab_location');
          this.context.setIsLocalLab(false);
          this.props.history.push(
            `/order-placed/${resp.data.orderitem[0].order}`
          );
          this.context.clearCart();
          this.setState({ placeOrderLoading: false });
        });
      })
      .catch((error) => {
        //console.log(error.response.data);
      });
  };

  confirmPayment = (clearCart, setPaymentSuccessTotal, setIsLocalLab) => {
    // //console.log('Confirm Order,');
    let numberPattern = /^01\d{9}$/;
    if (this.state.date === '' || this.state.date === null) {
      toast.error('Please select date.', {
        autoClose: 3000,
      });
    } else if (this.state.district.trim() === '') {
      toast.error('Please select your location district.', {
        autoClose: 3000,
      });
    } else if (this.state.thana.trim() === '') {
      toast.error('Please select your location area.', {
        autoClose: 3000,
      });
    } else if (this.state.address.trim() === '') {
      toast.error('Please enter address.', {
        autoClose: 3000,
      });
    } else if (!numberPattern.test(this.state.mobile)) {
      toast.error('Please enter a valid mobile number.', {
        autoClose: 3000,
      });
    } else if (!this.state.selectTerms) {
      toast.error('Please checked Terms of Service', {
        autoClose: 3000,
      });
      window.scroll({ top: 1200, left: 0, behavior: 'smooth' });
      return;
    } else {
      this.setState({ placeOrderLoading: true });
      let storedUserId = this.context.userId;
      if (!storedUserId) {
        const raw = localStorage.getItem('user_id');
        if (raw) {
          try {
            storedUserId = JSON.parse(raw);
          } catch (e) {
            storedUserId = raw;
          }
        }
      }

      const postAddress = {
        district: this.state.district,
        thana: this.state.thana,
        address: this.state.address,
        mobile: this.state.mobile,
        email: this.state.email,
        patient:
          this.context.suMyself.length !== 0
            ? this.context.suMyself[0].id
            : null,
        user: storedUserId || null,
        status: true,
      };

      const targetAddressId = this.state.addressId || (this.state.userAddresses && this.state.userAddresses.length >= 2 ? this.state.userAddresses[0].id : null);

      if (targetAddressId) {
        axios
          .put(
            `${process.env.REACT_APP_BASE_URL}/user_management/address/${targetAddressId}/`,
            postAddress
          )
          .then((resp) => {
            // console.log(resp.data);
            this.postOrderAndDetails(resp.data.id);
          })
          .catch((error) => {
            // console.log(error.response);
          });
      } else {
        axios
          .post(
            `${process.env.REACT_APP_BASE_URL}/user_management/address/`,
            postAddress
          )
          .then((resp) => {
            // console.log(resp.data.id);
            // const add_id = resp.data.id;
            this.postOrderAndDetails(resp.data.id);
          })
          .catch((error) => {
            console.log(error.response);
            if (error.response.status === 400) {
              if (error.response.data.address) {
                toast.error(`Address: ${error.response.data.address[0]}`, {
                  autoClose: 3000,
                });
              }
            }
          });
      }
    }
  };

  cuponAndCartMatch = (data) => {
    // console.log(data);
    if (!this.isLabDiscountAllowedForUser(data)) {
      toast.error('Sorry, coupon is not valid.');
      return;
    }

    let newCollectionFees, newMaterialFees;
    data.is_collection_fee
      ? (newCollectionFees = 0)
      : (newCollectionFees = this.state.fees.collection_fee);

    data.is_material_fee
      ? (newMaterialFees =
          this.state.fees.meterial_fee -
          (this.state.fees.meterial_fee * data.material_rate_percentage) / 100)
      : (newMaterialFees = this.state.fees.meterial_fee);

    this.setState({
      fees: {
        meterial_fee: newMaterialFees,
        collection_fee: newCollectionFees,
      },
    });

    const diagnostics = this.state.carts.filter((diagnostic) => {
      return diagnostic.order_type === 'diagnostic';
    });
    const packages = this.state.carts.filter((name) => {
      return name.order_type === 'package';
    });

    let cartLabs = [];

    if (diagnostics.length !== 0) {
      const labDetails = diagnostics.map((lab) => {
        return {
          labName: lab.test_item.branch.lab.name,
          id: lab.test_item.branch.lab.id,
        };
      });
      // console.log(labDetails);
      cartLabs.push(...labDetails);
    } else {
      const labDetails = packages.map((lab) => {
        return {
          labName: lab.package.test_item.branch.lab.name,
          id: lab.package.test_item.branch.lab.id,
        };
      });
      // console.log(labDetails);
      cartLabs.push(...labDetails);
    }

    let cartBranches = [];

    if (diagnostics.length !== 0) {
      const labDetails = diagnostics.map((lab) => {
        return {
          branchName: lab.test_item.branch.name,
          id: lab.test_item.branch.id,
        };
      });
      // console.log(labDetails);
      cartBranches.push(...labDetails);
    } else {
      const labDetails = packages.map((lab) => {
        return {
          branchName: lab.package.test_item.branch.name,
          id: lab.package.test_item.branch.id,
        };
      });
      // console.log(labDetails);
      cartBranches.push(...labDetails);
    }

    const cuponTests = data.cct;
    const cuponPackages = data.ccp;
    const cuponLabs = data.ccl;
    const cuponBranches = data.ccb;

    // Every cart row with a covered test/package, not just the first - the
    // same test for two patients must be discounted twice. This used find(),
    // so on mobile only the first patient's row got the discount while the
    // desktop checkout (filter) discounted all of them.
    let matchedTests = [];
    cuponTests.forEach((cupId) => {
      let existing = diagnostics.filter(
        (diagId) => diagId.test_item.diagnostic_test.id === cupId.test
      );

      if (existing) {
        matchedTests.push(...existing);
      }
    });

    let matchedPackages = [];
    cuponPackages.forEach((cupId) => {
      let existing = packages.filter(
        (packId) => packId.package.package.id === cupId.package
      );

      if (existing) {
        matchedPackages.push(...existing);
      }
    });

    let matchedLabs = [];
    cuponLabs.forEach((cupId) => {
      let existing = cartLabs.find((packId) => packId.id === cupId.lab);

      if (existing) {
        matchedLabs.push(existing);
      }
    });

    let matchedBranches = [];
    cuponBranches.forEach((cupId) => {
      let existing = cartBranches.find((packId) => packId.id === cupId.branch);

      if (existing) {
        matchedBranches.push(existing);
      }
    });

    // console.log('Tests: ', matchedTests);
    // console.log('Packages: ', matchedPackages);
    // console.log('Labs: ', matchedLabs);

    if (data.is_branch) {
      // console.log('Calculate Branch');
      // console.log(data);
      // console.log('Tests: ', matchedTests);
      // console.log('Packages: ', matchedPackages);
      // console.log('Branches: ', matchedBranches);

      if (matchedBranches.length !== 0) {
        const priceArray = [...matchedTests, ...matchedPackages];
        const percentAmount =
          this.getTotalPrice(priceArray) * (data.rate / 100);
        this.setState({ discountAmount: parseInt(percentAmount) });

        const newTestCart = [...matchedTests].map((cart) => {
          return {
            ...cart,
            criteria: data.criteria,
            rate: cart.rate ? cart.rate + data.rate : data.rate,
            is_collection_fee: cart.is_collection_fee
              ? cart.is_collectio
              : data.is_collection_fee,
            is_material_fee: cart.is_material_fee
              ? cart.is_material_fee
              : data.is_material_fee,
            material_rate_percentage: cart.material_rate_percentage
              ? cart.material_rate_percentage + data.material_rate_percentage
              : data.material_rate_percentage,
          };
        });

        const newPackageCart = [...matchedPackages].map((cart) => {
          return {
            ...cart,
            criteria: data.criteria,
            rate: cart.rate ? cart.rate + data.rate : data.rate,
            is_collection_fee: cart.is_collection_fee
              ? cart.is_collectio
              : data.is_collection_fee,
            is_material_fee: cart.is_material_fee
              ? cart.is_material_fee
              : data.is_material_fee,
            material_rate_percentage: cart.material_rate_percentage
              ? cart.material_rate_percentage + data.material_rate_percentage
              : data.material_rate_percentage,
          };
        });

        const newCart = this.state.carts.map((cart) => {
          const matched = newTestCart.find(
            (test) =>
              test.patient === cart.patient &&
              test.test_item === cart.test_item
          );
          // copy the match so duplicate rows never share one object reference
          return matched ? { ...matched } : cart;
        });
        this.setState({ carts: newCart });
        setTimeout(() => {
          this.serviceFeesRemove(this.state.carts);
        }, 300);

        const newCart1 = this.state.carts.map((cart) => {
          const matched = newPackageCart.find(
            (test) =>
              test.patient === cart.patient && test.package === cart.package
          );
          // copy the match so duplicate rows never share one object reference
          return matched ? { ...matched } : cart;
        });
        this.setState({ carts: newCart1 });
        setTimeout(() => {
          this.serviceFeesRemove(this.state.carts);
        }, 300);

        this.setState({ showDiscount: true });
        toast.success('Congratulation, coupon matched.', {
          autoClose: 3000,
        });
        this.setState({ cuponId: data.id });
      } else {
        toast.error('Sorry, coupon is not valid.');
      }
    } else {
      if (
        data.cca.length === 0 &&
        // data.ccl.length === 0 &&
        data.ccp.length === 0 &&
        data.cct.length === 0
      ) {
        if (data.criteria === 'static') {
          this.setState({ discountAmount: data.rate });
        } else {
          const percentAmount =
            this.getTotalPrice(this.state.carts) * (data.rate / 100);
          // console.log(parseInt(percentAmount));
          this.setState({ discountAmount: parseInt(percentAmount) });
        }

        const newCart = this.state.carts.map((cart) => {
          return {
            ...cart,
            criteria: data.criteria,
            rate: cart.rate ? cart.rate + data.rate : data.rate,
            is_collection_fee: cart.is_collection_fee
              ? cart.is_collectio
              : data.is_collection_fee,
            is_material_fee: cart.is_material_fee
              ? cart.is_material_fee
              : data.is_material_fee,
            material_rate_percentage: cart.material_rate_percentage
              ? cart.material_rate_percentage + data.material_rate_percentage
              : data.material_rate_percentage,
          };
        });
        this.setState({ carts: newCart });
        setTimeout(() => {
          this.serviceFeesRemove(this.state.carts);
        }, 300);

        toast.success('Congratulation, coupon matched.', {
          autoClose: 3000,
        });
        this.setState({ showDiscount: true });
        this.setState({ cuponId: data.id });
      } else if (matchedTests.length !== 0 || matchedPackages.length !== 0) {
        if (data.criteria === 'static') {
          this.setState({ discountAmount: data.rate });
        } else {
          const priceArray = [...matchedTests, ...matchedPackages];
          // console.log(priceArray);
          const percentAmount =
            this.getTotalPrice(priceArray) * (data.rate / 100);
          // console.log(percentAmount);
          this.setState({ discountAmount: parseInt(percentAmount) });
        }

        const newTestCart = [...matchedTests].map((cart) => {
          return {
            ...cart,
            criteria: data.criteria,
            rate: cart.rate ? cart.rate + data.rate : data.rate,
            is_collection_fee: cart.is_collection_fee
              ? cart.is_collectio
              : data.is_collection_fee,
            is_material_fee: cart.is_material_fee
              ? cart.is_material_fee
              : data.is_material_fee,
            material_rate_percentage: cart.material_rate_percentage
              ? cart.material_rate_percentage + data.material_rate_percentage
              : data.material_rate_percentage,
          };
        });

        const newPackageCart = [...matchedPackages].map((cart) => {
          return {
            ...cart,
            criteria: data.criteria,
            rate: cart.rate ? cart.rate + data.rate : data.rate,
            is_collection_fee: cart.is_collection_fee
              ? cart.is_collectio
              : data.is_collection_fee,
            is_material_fee: cart.is_material_fee
              ? cart.is_material_fee
              : data.is_material_fee,
            material_rate_percentage: cart.material_rate_percentage
              ? cart.material_rate_percentage + data.material_rate_percentage
              : data.material_rate_percentage,
          };
        });

        const newCart = this.state.carts.map((cart) => {
          const matched = newTestCart.find(
            (test) =>
              test.patient === cart.patient &&
              test.test_item === cart.test_item
          );
          // copy the match so duplicate rows never share one object reference
          return matched ? { ...matched } : cart;
        });
        this.setState({ carts: newCart });
        setTimeout(() => {
          this.serviceFeesRemove(this.state.carts);
        }, 300);

        const newCart1 = this.state.carts.map((cart) => {
          const matched = newPackageCart.find(
            (test) =>
              test.patient === cart.patient && test.package === cart.package
          );
          // copy the match so duplicate rows never share one object reference
          return matched ? { ...matched } : cart;
        });
        this.setState({ carts: newCart1 });
        setTimeout(() => {
          this.serviceFeesRemove(this.state.carts);
        }, 300);

        this.setState({ showDiscount: true });
        toast.success('Congratulation, coupon matched.', {
          autoClose: 3000,
        });
        this.setState({ cuponId: data.id });
      } else {
        toast.error('Sorry, coupon is not valid.', {
          autoClose: 3000,
        });
      }
    }
  };

  coupontRange = (x, y, str) => {
    let numbers = [];
    for (let i = x; i <= y; i++) {
      numbers.push(`${str}${i}`);
    }
    return numbers;
  };

  couponRangeCheck = () => {
    const letter = this.state.coupon.match(/[a-zA-Z]+/g);
    const number = this.state.coupon.match(/\d+/g);

    // console.log(letter);
    // console.log(number);

    axios
      .get(`${process.env.REACT_APP_BASE_URL}/diagnostic/cupon/?code=${letter}`)
      .then((resp) => {
        if (resp.data.results.length !== 0) {
          const data = resp.data.results
            .filter((coupon) => coupon.is_active)
            .filter((coupon) => {
              const expire_day = moment(coupon.expired_at)
                .add(1, 'days')
                .format('YYYY-MM-DD')
                .toString();
              const isSameOrAfter = moment(expire_day).isSameOrAfter(
                this.state.today
              );

              if (isSameOrAfter) {
                return coupon;
              }
            })
            .filter((coupon) => this.isLabDiscountAllowedForUser(coupon));

          if (data.length === 0) {
            toast.error('Sorry, this coupon is not valid.');
          } else {
            // console.log(data);
            const cartLab = this.state.carts.map((cart) =>
              cart.order_type === 'diagnostic'
                ? cart.test_item.branch.lab.id
                : cart.package.test_item.branch.lab.id
            );
            const cartLabId = cartLab[0];

            if (1 < data.length) {
              const getCouponLab = data.filter((labs) =>
                labs.ccl.some((lab) => lab.lab === cartLabId)
              );

              if (getCouponLab.length !== 0) {
                // this.cuponAndCartMatch(getCouponLab.at(-1));
                const couponDet = getCouponLab.at(-1);
                if (couponDet.is_code_range) {
                  // console.log(couponDet);

                  const array = this.coupontRange(
                    couponDet.code_start,
                    couponDet.code_end,
                    couponDet.code
                  );
                  // console.log(array.includes(this.state.coupon));
                  if (array.includes(this.state.coupon)) {
                    this.cuponAndCartMatch(couponDet);
                  } else {
                    toast.error('Sorry, this coupon is not valid.');
                  }
                  // array.includes('amarlab10000');
                } else {
                  toast.error('Sorry, this coupon is not valid.');
                }
              } else {
                toast.error('Sorry, this coupon is not valid.');
              }
            } else {
              if (data[0].is_code_range) {
                const couponDet = data[0];
                // console.log(couponDet);
                if (couponDet.is_code_range) {
                  // console.log(couponDet);

                  const array = this.coupontRange(
                    couponDet.code_start,
                    couponDet.code_end,
                    couponDet.code
                  );
                  // console.log(array.includes(this.state.coupon));
                  if (array.includes(this.state.coupon)) {
                    this.cuponAndCartMatch(couponDet);
                  } else {
                    toast.error('Sorry, this coupon is not valid.');
                  }
                  // array.includes('amarlab10000');
                } else {
                  toast.error('Sorry, this coupon is not valid.');
                }
              } else {
                toast.error('Sorry, this coupon is not valid.');
              }
            }
          }
        } else {
          toast.error('Sorry, this coupon is not valid.');
        }
      })
      .catch(() => {
        toast.error('Sorry, this coupon is not valid.');
      });
  };

  fetchCoupon = (code) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/diagnostic/cupon/?code=${code}`)
      .then((resp) => {
        // console.log(resp.data.results);
        if (resp.data.results.length !== 0) {
          const data = resp.data.results
            .filter((coupon) => coupon.is_active)
            .filter((coupon) => {
              const expire_day = moment(coupon.expired_at)
                .add(1, 'days')
                .format('YYYY-MM-DD')
                .toString();
              const isSameOrAfter = moment(expire_day).isSameOrAfter(
                this.state.today
              );

              if (isSameOrAfter) {
                return coupon;
              }
            })
            .filter((coupon) => this.isLabDiscountAllowedForUser(coupon));

          // console.log(data);
          if (data.length === 0) {
            // toast.error('Sorry, this coupon is not valid.');
            this.couponRangeCheck();
          } else {
            // console.log('do something with coupon');
            // this.cuponAndCartMatch(data);
            const cartLab = this.state.carts.map((cart) =>
              cart.order_type === 'diagnostic'
                ? cart.test_item.branch.lab.id
                : cart.package.test_item.branch.lab.id
            );
            const cartLabId = cartLab[0];
            // console.log(data);
            // console.log(cartLabId);

            if (1 < data.length) {
              const getCouponLab = data.filter((labs) =>
                labs.ccl.some((lab) => lab.lab === cartLabId)
              );
              // console.log(getCouponLab);
              if (getCouponLab.length !== 0) {
                // console.log(getCouponLab.at(-1).is_code_range);
                if (!getCouponLab.at(-1).is_code_range) {
                  this.cuponAndCartMatch(getCouponLab.at(-1));
                } else {
                  // toast.error('Sorry, this coupon is not valid.');
                  this.couponRangeCheck();
                }
              } else {
                // toast.error('Sorry, this coupon is not valid.');
                this.couponRangeCheck();
              }
            } else {
              if (!data[0].is_code_range) {
                this.cuponAndCartMatch(data[0]);
              } else {
                // toast.error('Sorry, this coupon is not valid.');
                this.couponRangeCheck();
              }
            }
          }
        } else {
          // toast.error('Sorry, this coupon is not valid.', {
          //   autoClose: 3000,
          // });
          this.couponRangeCheck();
        }
      })
      .catch((error) => {
        this.couponRangeCheck();
      });
  };

  handleCoupon = (e) => {
    e.preventDefault();
    if (this.state.coupon.trim() === '') {
      toast.error('Please enter coupon code.', {
        autoClose: 3000,
      });
    } else {
      this.fetchCoupon(this.state.coupon);
    }
  };

  getFirstName = (name) => {
    const nameArray = name.split(' ');
    if (nameArray.length < 2) {
      return name;
    } else {
      const firstname = nameArray.slice(0, -1).join(' ');
      return firstname;
    }
  };

  handleMeterialPerson = (array) => {
    const patients = array
      .map((patient) => {
        return patient.patient.id;
      })
      .filter((x, i, a) => a.indexOf(x) === i);
    // console.log(patients.length);
    this.setState({ materialPerson: patients.length });
  };

  handleExmClick = () => {
    const orderType = this.state.carts.map((cart) => {
      return cart.order_type === 'diagnostic'
        ? cart.test_item.diagnostic_test.is_covid
        : cart.package.test_item.diagnostic_test.is_covid;
    });

    console.log(orderType.includes(true) ? 'covid' : 'non_covid');
  };

  render() {
    const {
      coupon,
      showDiscount,
      discountAmount,
      labDiscount,
      placeOrderLoading,
      deliveryCopy,
    } = this.state;
    const { setCartsItem, clearCart, setPaymentSuccessTotal, setIsLocalLab } =
      this.context;
    // //console.log(carts);
    return (
      <>
        <section className='checkout'>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-4 mobile-first'>
                <h5 className='summery'>Order Summary</h5>
                <div className='calculation'>
                  <div className='order-summery'>
                    <div className='list'>
                      <p className='name'>Total Price</p>
                      <p className='price'>
                        ৳ {this.getTotalPrice(this.state.carts)}
                      </p>
                    </div>
                    {this.state.carts &&
                      this.state.carts.length &&
                      this.state.carts[0].order_type !== 'package' && (
                        <>
                          <div className='list'>
                            <p className='name'>
                              Material fee ৳{this.state.fees.meterial_fee} *{' '}
                              {this.state.materialPerson || '0'}
                            </p>
                            <p className='price'>
                              ৳{' '}
                              {this.getGroupedMaterialFeeTotal(this.state.carts)}
                            </p>
                          </div>
                          <div className='list'>
                            <p className='name'>Collection fee </p>
                            <p className='price'>
                              ৳ {this.shownCollectionFee()}
                            </p>
                          </div>
                        </>
                      )}

                    <div className='break'></div>
                    <div className='list total'>
                      <p className='name'>Total: </p>
                      <p className='price'>
                        ৳ {this.getTotalPriceWithFees(this.state.carts)}
                      </p>
                    </div>
                    {this.state.labDisLoading && (
                      <div className='list load'>
                        <p className='name'>Loading Lab Discount</p>
                        <p className='price'>
                          <Spinner animation='border' variant='dark' />
                        </p>
                      </div>
                    )}
                    {labDiscount && !this.brandOutcome().replacesOthers && (
                      <div className='list'>
                        <p className='name'>Discount</p>
                        <p className='price'>- ৳ {labDiscount || '00'}</p>
                      </div>
                    )}
                    {this.brandOutcome().brandApplied && (
                      <div className='list' style={{ backgroundColor: '#eaf8f9', padding: '6px 10px', borderRadius: '6px', margin: '6px 0', border: '1px solid #31b5c4' }}>
                        <div>
                          <p className='name mb-0' style={{ color: '#097380', fontWeight: 'bold' }}>
                            🎁 {this.state.brandDiscount.name}
                          </p>
                          {this.state.brandDiscount.reason && (
                            <small className='text-muted d-block' style={{ fontSize: '11px', marginTop: '2px' }}>
                              {this.state.brandDiscount.reason}
                            </small>
                          )}
                        </div>
                        <p className='price mb-0' style={{ color: '#097380', fontWeight: 'bold' }}>
                          - ৳ {this.state.brandDiscount.discount_amount || '00'}
                        </p>
                      </div>
                    )}
                    {this.brandOutcome().brandApplied && this.brandOutcome().waived > 0 && (
                      <div className='list'>
                        <p className='name' style={{ color: '#097380' }}>
                          {this.state.brandDiscount.waive_collection_fee && this.state.brandDiscount.waive_material_fee
                            ? 'Free collection & material fee'
                            : this.state.brandDiscount.waive_collection_fee
                              ? 'Free home collection'
                              : 'Free material fee'}
                        </p>
                        <p className='price' style={{ color: '#097380' }}>- ৳ {this.brandOutcome().waived}</p>
                      </div>
                    )}
                    {showDiscount && !this.brandOutcome().replacesOthers && (
                      <div className='list'>
                        <p className='name'>Coupon Applied</p>
                        <p className='price'>- ৳ {discountAmount || '00'}</p>
                      </div>
                    )}
                    <div className='break bottom'></div>
                    <div className='list payable mb-0'>
                      <p className='name'>Payable: </p>
                      <p className='price'>
                        ৳{' '}
                        {this.getTotalPriceWithFeesWithCoupon(this.state.carts)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-8'>
                <form className='details'>
                  <h1 className='main-heading web'>Order Service</h1>
                  <h1 className='main-heading mobile'>
                    Order Details <span> (Fill-Up Booking Info.)</span>
                  </h1>
                  <div className='row items time'>
                    <div className='col-md-5 left'>
                      <h5>Sample Collection Date*</h5>
                      <p>
                        This schedule is not confirmed, wait till our team
                        communicates you.
                      </p>
                    </div>
                    <div className='col-md-7 right'>
                      {/* <DateSelect
                        defaultDate={this.state.date}
                        setDefaultDate={this.setDefaultDate}
                      /> */}
                      <MuiPickersUtilsProvider
                        libInstance={moment}
                        utils={MomentUtils}
                      >
                        <DatePicker
                          // disableToolbar
                          disablePast
                          autoOk={true}
                          variant='dialog'
                          format='YYYY-MM-DD'
                          margin='normal'
                          id='date-picker'
                          value={this.state.date}
                          error={false}
                          helperText={null}
                          onChange={this.setDefaultDate}
                          placeholder='YYYY - MM - DD'
                          // KeyboardButtonProps={{
                          //   'aria-label': 'change date'
                          // }}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>
                  {this.state.userAddresses && this.state.userAddresses.length > 0 && (
                    <div className='row items select-address' style={{ marginBottom: '12px' }}>
                      <div className='col-md-5 left'>
                        <h5 style={{ marginBottom: '3px' }}>Saved Addresses</h5>
                        <p style={{ margin: 0 }}>Select which saved address to use</p>
                      </div>
                      <div className='col-md-7 right'>
                        <div className='row'>
                          {this.state.userAddresses.map((addr, idx) => (
                            <div className='col-12 mb-2' key={addr.id}>
                              <div
                                onClick={() => this.selectSavedAddress(addr)}
                                style={{
                                  border: this.state.addressId === addr.id ? '2px solid #31b5c4' : '1px solid #cacad3',
                                  backgroundColor: this.state.addressId === addr.id ? '#f0fbfc' : '#fff',
                                  borderRadius: '8px',
                                  padding: '10px 12px',
                                  cursor: 'pointer',
                                }}
                              >
                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                  <span style={{ fontWeight: 600, color: '#1b3b6f', fontSize: '13px' }}>
                                    Address {idx + 1} {idx === 0 ? '(Latest)' : ''}
                                  </span>
                                  <div className='d-flex align-items-center' style={{ gap: '8px' }}>
                                    <button
                                      type='button'
                                      className='btn btn-link p-0'
                                      style={{ color: '#31b5c4', fontSize: '12px', fontWeight: 600, textDecoration: 'none' }}
                                      title='Edit this address'
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        this.props.history.push(`/profile?tab=address&editAddressId=${addr.id}&redirect=/checkout`);
                                      }}
                                    >
                                      <i className='fa fa-edit mr-1'></i>Edit
                                    </button>
                                    <input
                                      type='radio'
                                      name='checkout_mbl_selected_address'
                                      checked={this.state.addressId === addr.id}
                                      onChange={() => this.selectSavedAddress(addr)}
                                      style={{ accentColor: '#31b5c4', cursor: 'pointer', margin: 0 }}
                                    />
                                  </div>
                                </div>
                                <div style={{ fontSize: '12px', color: '#555', lineHeight: '1.4' }}>
                                  <div><strong>Area:</strong> {addr.thana ? `${addr.thana}, ` : ''}{addr.district}</div>
                                  <div style={{ wordBreak: 'break-word', whiteSpace: 'pre-line' }}><strong>Address:</strong> {addr.address}</div>
                                  {addr.mobile && <div><strong>Mobile:</strong> {addr.mobile}</div>}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                  <div className='row items location'>
                    <div className='col-md-5 left'>
                      <h5>Location*</h5>
                      <p>
                        Your test sample will be collected from this location
                      </p>
                    </div>
                    <div className='col-md-7 right'>
                      <div className='row'>
                        <div className='col-6 sel-one'>
                          <select
                            className=''
                            onChange={this.handleSelect}
                            value={this.state.district}
                          >
                            <option value=''>Select District</option>
                            <option value='Dhaka'>Dhaka</option>
                            <option value='Savar'>Savar</option>
                            <option value='Chattogram'>Chattogram</option>
                          </select>
                        </div>
                        <div className='col-6 sel-two'>
                          <select
                            className=''
                            onChange={(e) =>
                              this.setState({ thana: e.target.value })
                            }
                            value={this.state.thana}
                          >
                            <option value=''>Select Area</option>
                            {this.state.selectLoopItem.map((item, i) => (
                              <option key={i} value={item}>
                                {item}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='col-md-5'></div>
                    <div className='col-md-7 right'>
                      <textarea
                        className='form-control'
                        placeholder='Enter Location Details*'
                        onChange={(e) =>
                          this.setState({ address: e.target.value })
                        }
                        value={this.state.address}
                      ></textarea>
                    </div>
                    {/* <div className='col-md-5'></div>
                    <div className='col-md-7 right'>
                      <input
                        type='text'
                        className='form-control'
                        placeholder='Nearby Popular Landmark'
                      />
                    </div> */}
                  </div>
                  <div className='row items mobile'>
                    <div className='col-md-5 left'>
                      <h5>Mobile Number*</h5>
                      <p>We will call you in every necessary steps</p>
                    </div>
                    <div className='col-md-7 right'>
                      <input
                        type='text'
                        className='form-control'
                        placeholder='01xxxxxxx'
                        value={this.state.mobile}
                        onChange={(e) =>
                          this.setState({ mobile: e.target.value })
                        }
                      />
                    </div>
                  </div>
                  <div className='row items email'>
                    <div className='col-md-5 left'>
                      <h5>Email</h5>
                      <p>Your report will be sent on this email address</p>
                    </div>
                    <div className='col-md-7 right'>
                      <input
                        type='email'
                        className='form-control'
                        placeholder='Enter Email'
                        value={this.state.email}
                        onChange={(e) =>
                          this.setState({ email: e.target.value })
                        }
                      />
                    </div>
                  </div>
                  <div className='row items refrence'>
                    <div className='col-md-5 left'>
                      <h5>Reference (if any)</h5>
                      <p>For references, corporate discounts & special notes</p>
                    </div>
                    <div className='col-md-7 right'>
                      <textarea
                        className='form-control'
                        placeholder='Enter reference'
                        onChange={(e) =>
                          this.setState({ reference: e.target.value })
                        }
                      ></textarea>
                    </div>
                  </div>
                  <div className='row items delivery-copy'>
                    <div className='col-md-5 left'>
                      <h5>Report Delivery Mode</h5>
                      <p>Your report will be delivered via email or hand</p>
                    </div>
                    <div className='col-md-7 right'>
                      <select
                        value={deliveryCopy}
                        onChange={(e) => {
                          this.setState({ deliveryCopy: e.target.value }, () => {
                            this.getFees(this.state.carts);
                          });
                        }}
                      >
                        <option value='hard'>Hard Copy</option>
                        <option value='soft'>Soft Copy</option>
                        <option value='both'>Both</option>
                      </select>
                    </div>
                  </div>
                  <div className='row items t-and-c'>
                    <div className='col-md-12 left'>
                      <input
                        value='TermsService'
                        type='checkbox'
                        id='TermsService'
                        defaultChecked={this.state.selectTerms}
                        onChange={(e) =>
                          this.setState({
                            selectTerms: e.target.checked,
                          })
                        }
                      />
                      <h5>
                        * By completing your purchase you agree to this{' '}
                        <Link to='/terms-of-service' target="_blank" rel="noopener noreferrer">Terms of Service.</Link>
                      </h5>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-12 amount'>
                      <div className='bg-primary'>
                        <div className='left'>
                          <h5>Total Payable Amount</h5>
                          <div className='price'>
                            ৳{' '}
                            {this.getTotalPriceWithFeesWithCoupon(
                              this.state.carts
                            )}
                            {/* 00000 */}
                          </div>
                        </div>
                        {/* <div className='right'>
                          <button
                            className='btn btn-warning'
                            onClick={() => this.confirmPayment(clearCart)}
                            type='button'
                          >
                            Pay Now
                          </button>
                        </div> */}
                      </div>
                    </div>
                    <div className='col-12 terms'>
                      * By completing your purchase you agree to this{' '}
                      <Link to='/terms-of-service' target="_blank" rel="noopener noreferrer">Terms of Service.</Link>
                    </div>
                  </div>
                </form>
              </div>
              <button
                onClick={() =>
                  this.confirmPayment(
                    clearCart,
                    setPaymentSuccessTotal,
                    setIsLocalLab
                  )
                }
                disabled={this.state.carts.length !== 0 ? '' : 'disabled'}
                className='mbl-sticky btn btn-primary btn-block shadow-sm'
              >
                Place Order
              </button>
            </div>
          </div>
        </section>

        <Helmet>
          <script>
            {`
            gtag('event', 'conversion', {'send_to': 'AW-10778978942/sA9mCNrP070DEP7U6JMo'});
          `}
          </script>
        </Helmet>
      </>
    );
  }
}

export default CheckoutMbl;

CheckoutMbl.contextType = AuthContext;
